import HTTPError from "./HTTPError";

export default class HTTPErrorWithBody extends HTTPError {
  constructor(body = null, ...params) {
    super(401, ...params);
    this.body = body;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, HTTPErrorWithBody);
    }
  }
}
